import React from "react";

import checkIcon from "../../../images/table-image/icon/check-icon.svg";
import Sharing from "../shared/Sharing";
import QASectionPopupSettings from "./QASectionPopupSettings";

type Props = {
  canManageSections?: boolean;
  editable?: boolean;
  inEditMode?: boolean;
  isAdmin?: boolean;
  moduleWorkspaceID?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDelete?: (...args: any[]) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRename?: (...args: any[]) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renameSectionTag?: (...args: any[]) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sectionTag?: any;
  tableName?: string;
};

function QASectionMenu({
  editable,
  inEditMode,
  renameSectionTag,
  isAdmin,
  moduleWorkspaceID,
  sectionTag,
  tableName,
  canManageSections,
  onRename,
  onDelete,
}: Props) {
  if (!editable) {
    return null;
  }
  return (
    <div className="dropdown-public-block">
      {inEditMode && (
        <div className="dropdown-check-icon" onClick={renameSectionTag}>
          <img src={checkIcon} alt="icon" />
        </div>
      )}
      {isAdmin && (
        <Sharing
          moduleWorkspaceID={moduleWorkspaceID}
          objectID={sectionTag.id}
          selectedDepartmentIDs={sectionTag.department_ids}
          selectedUserIDs={sectionTag.user_ids}
          tableName={tableName}
        />
      )}
      {canManageSections && (
        <QASectionPopupSettings onDelete={onDelete} onRename={onRename} />
      )}
    </div>
  );
}

export default QASectionMenu;
